import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import "./ArtistStudio.css";
import "../../styles/font.css";
import { TopMenu } from '../../component/TopMenu';
import { getCookie } from '../../utils/authUtils';
import { API_CONFIG } from '../../config/api';

export const ArtistStudio = () => {

  const navigate = useNavigate();
  const [searchKeyword, setSearchKeyword] = useState('');
  const [activeTab, setActiveTab] = useState('overview');
  const [studioList, setStudioList] = useState([]);
  const [bookingsByStudio, setBookingsByStudio] = useState({});

  const [selectedStudioId, setSelectedStudioId] = useState(null);

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userType, setUserType] = useState(null); // 'user' or 'artist' or null
  const [userName, setUserName] = useState("");

  const gotoMain = () => {
    navigate('/');
  }

  const handleLogout = () => {
    // 일반 사용자 관련 모든 쿠키 삭제
    document.cookie = "yournest_u_id=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_u_login_id=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_u_name=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_u_email=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_u_phone=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_u_auth_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";

    // 작가 관련 모든 쿠키 삭제
    document.cookie = "yournest_a_id=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_login_id=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_name=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_profile=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_company=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_email=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_phone=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_description=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_type=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_address=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_lat=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_lng=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_auth_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    
    setIsAuthenticated(false);
    setUserType(null);
    setUserName("");
    alert("로그아웃 되었습니다");
  };

  useEffect(() => {
    const artistToken = getCookie('yournest_a_auth_token');
    if (artistToken) {
      verifyArtistToken(artistToken);
    }
  }, []);

  const verifyArtistToken = async (token) => {
    try {
      const response = await fetch(`${API_CONFIG.MAIN}/verify_artist_token`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ auth_token: token }),
      });

      if (response.ok) {
        const data = await response.json();
        setIsAuthenticated(true);
        setUserType('artist');
        setUserName(data.artist_name);
      } else {
        setIsAuthenticated(false);
        setUserType(null);
      }
    } catch (error) {
      console.error('Token verification error:', error);
      setIsAuthenticated(false);
      setUserType(null);
    }
  };
  
  useEffect(() => {
    const artistAuthToken = getCookie('yournest_a_auth_token');
    if (!artistAuthToken) {
      alert('로그인이 필요한 서비스입니다.');
      navigate('/login');
      return;
    }
    fetchStudioList();
  }, []);

  const getStatusText = (status) => {
    switch (status) {
      case 'pending':
        return '대기중';
      case 'completed':
        return '완료';
      default:
        return '알 수 없음';
    }
  };

  const fetchStudioList = async () => {
    try {
      const artistId = getCookie('yournest_a_id');
      const response = await fetch(`${API_CONFIG.MAIN}/get_artist_studios`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ artist_id: artistId })
      });
      
      if (!response.ok) throw new Error('스튜디오 목록 조회 실패');
      const data = await response.json();
      if (data.isSuccess) {
        setStudioList(data.studios);
      }
    } catch (error) {
      console.error('스튜디오 목록 조회 실패:', error);
    }
  };

  const fetchBookings = async (tourId) => {
    try {
      const response = await fetch(`${API_CONFIG.MAIN}/get_studio_bookings`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ tour_id: tourId })
      });

      if (!response.ok) {
        throw new Error('예약 내역 조회 실패');
      }

      const data = await response.json();
      if (data.isSuccess) {
        setBookingsByStudio(prev => ({
          ...prev,
          [tourId]: data.bookings
        }));
      }
    } catch (error) {
      console.error('예약 내역 조회 중 오류 발생:', error);
    }
  };

  useEffect(() => {
    if (studioList.length > 0) {
      studioList.forEach(studio => {
        fetchBookings(studio.id);
      });
    }
  }, [studioList]);

  const renderBookingsTab = () => {
    return (
      <div className="studio-content__bookings">
        <div className="studio-content__studio-selector">
          <select 
            value={selectedStudioId || ''} 
            onChange={(e) => setSelectedStudioId(e.target.value ? Number(e.target.value) : null)}
            className="studio-content__studio-select"
          >
            <option value="">모든 스튜디오</option>
            {studioList.map(studio => (
              <option key={studio.id} value={studio.id}>
                {studio.tour_name}
              </option>
            ))}
          </select>
        </div>

        {studioList
          .filter(studio => !selectedStudioId || studio.id === Number(selectedStudioId))
          .map(studio => (
            <div key={studio.id} className="studio-content__studio-bookings">
              <h3>{studio.tour_name}</h3>
              <div className="studio-content__bookings-list">
                {bookingsByStudio[studio.id]?.map(booking => (
                  <div key={booking.booking_id} className="studio-content__booking-item">
                    <div className="studio-content__booking-header">
                      <span>{booking.user_name}</span>
                      <span className="studio-content__booking-status">
                        예약: {getStatusText(booking.reservation_status)} / 결제: {getStatusText(booking.payment_status)}
                      </span>
                    </div>
                    <div className="studio-content__booking-details">
                      <p>예약 일시: {booking.reservation_date} {booking.reservation_time}</p>
                      <p>인원: {booking.amount}명</p>
                      <p>결제 금액: {booking.payment_amount.toLocaleString()}원</p>
                      <p>연락처: {booking.user_phone}</p>
                      <p>이메일: {booking.user_email}</p>
                    </div>
                  </div>
                ))}
                {(!bookingsByStudio[studio.id] || bookingsByStudio[studio.id].length === 0) && (
                  <div className="studio-content__no-bookings">
                    예약 내역이 없습니다.
                  </div>
                )}
              </div>
            </div>
          ))}
      </div>
    );
  };

  return (
    <div className="artist-studio">
      <TopMenu 
        isAuthenticated={isAuthenticated}
        userType={userType}
        searchKeyword={searchKeyword}
        setSearchKeyword={setSearchKeyword}
        handleLogout={handleLogout}
      />

      {/* Block: tab-block */}
      <div className="tab-block">
        <div className={`tab-block__tab${activeTab === 'overview' ? '--active' : ''}`} onClick={() => setActiveTab('overview')}>
          아틀리에 관리
        </div>
        <div className={`tab-block__tab${activeTab === 'bookings' ? '--active' : ''}`}onClick={() => setActiveTab('bookings')}>
          예약/결제 내역
        </div>
      </div>
      {/* Block: tab-block End */}

      {/* Block: studio-content */}
      <div className="studio-content">
        {/* activeTab: overview 또는 bookings. 사용자의 탭 선택에 따라 달라짐 */}
        {activeTab === 'overview' ? (
        <div className="studio-content__overview">
          <button onClick={() => navigate('/artist-studio/create')}>
            새 아틀리에 등록
          </button>
          <div className="studio-content__studio-list">
            {studioList.map(studio => (
              <div key={studio.id} className="studio-content__studio-item">
                <div className="studio-content__studio-item-main">
                  <img src={`${API_CONFIG.MAIN}/uploads/tour_profiles/${studio.tour_profile}`} alt={studio.tour_name} />
                  <div className="studio-content__studio-item-info">
                    <h3>{studio.tour_name}</h3>
                    <p>{studio.tour_description}</p>
                    <p>위치: {studio.tour_location}</p>
                    <p>가격: {studio.tour_price}원</p>
                  </div>
                </div>
                <button 
                  className="studio-content__edit-button"
                  onClick={() => navigate(`/artist-studio/edit/${studio.id}`)}>
                  수정
                </button>
              </div>
            ))}
          </div>
        </div>
        ) : (
          renderBookingsTab()
        )}
      </div>
    </div>
  );
};
